import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=76a5ceae&scoped=true"
import script from "./welfare.vue?vue&type=script&lang=js"
export * from "./welfare.vue?vue&type=script&lang=js"
import style0 from "./welfare.vue?vue&type=style&index=0&id=76a5ceae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a5ceae",
  null
  
)

export default component.exports